import React, { useContext } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Base } from 'src/components';
import FilterByDate from 'src/containers/UserProfile/FilterView/FilterByDate';
import { updateData } from 'src/pagesDashboard/PulseQuestionResults/context/actions';
import { PulseQuestionResultsContext } from 'src/pagesDashboard/PulseQuestionResults/context/PulseQuestionResultsProvider';
import sharedUtils from 'src/common/sharedUtils';
import STYLE from 'src/constants/style';
import CopyIconSVG from 'src/assets/copy-icon.svg';

const TopFilters = ({ setShowModal, questionId }) => {
  const { context, dispatch } = useContext(PulseQuestionResultsContext);
  const { enablePulseShareableLink } = useFlags();

  const setRange = (value, start, end) => {
    if (value === 'custom') {
      return dispatch(
        updateData({
          ...context,
          range: { value, start, end }
        })
      );
    }

    if (value) {
      dispatch(
        updateData({
          ...context,
          range: { value, start, end: undefined }
        })
      );
    }
  };

  const showShareButton = enablePulseShareableLink && questionId;

  return (
    <Base classes={STYLE.CONTAINER_BLUE}>
      <div className='w-full flex justify-between px-1'>
        {showShareButton ? (
          <button
            className='flex items-center gap-2 focus:outline-0 focus:outline-none cursor-pointer text-right tooltip text-purple'
            onClick={() => sharedUtils.copyToClipboard(
              `${process.env.URL}/pulse-shared-link/${questionId}`
            )}
          >
            <CopyIconSVG className='text-gray-400' />
            <span>Copy share link</span>
          </button>
        ) : null}
        <div className='flex items-center gap-2 ml-auto'>
          <button
            type='button'
            className='mb-1 text-purple underline pl-2 text-base my-auto'
            onClick={() => setShowModal(true)}
          >
            View participation stats
          </button>

          <div className='inline-block'>
            <FilterByDate
              dateRangeSelected={context.range}
              onSelectDateRange={setRange}
            />
          </div>
        </div>
      </div>
    </Base>
  );
};

export default TopFilters;
